export function formatLargeNumber(n: number | undefined, locale?: string): string {
  if (n === undefined || n === 0) {
    return formatWithLocale(0, locale);
  }

  const format = (value: number, divider: number, suffix: string) => {
    const scaled = value / divider;
    const [intPart] = scaled.toString().split('.');
    const shouldRound = intPart.length >= 3;

    if (shouldRound) {
      return `${formatWithLocale(Math.round(scaled), locale)}${suffix}`;
    }

    const formatted = formatWithLocale(scaled, locale, 1);
    return `${trimTrailingZero(formatted)}${suffix}`;
  };

  if (n >= 1_000_000_000) return format(n, 1_000_000_000, 'B');
  if (n >= 1_000_000) return format(n, 1_000_000, 'M');
  if (n >= 1_000) return format(n, 1_000, 'K');

  return formatWithLocale(n, locale);
}

const formatWithLocale = (value: number, locale?: string, fractionDigits = 0) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
};

const trimTrailingZero = (value: string) => value.replace(/([.,])0$/, '');
